<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="header-right-box">
<div class="date-filter-div integration-status-box">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="22" nzLg="20" nzXl="14" class="btnsearch">
    <input type="text" class="form-control date-picker input mr-1" [readonly]="true" ngxDaterangepickerMd
        [(ngModel)]="selected" (ngModelChange)="onDateChange($event)" placeholder="Filter By Date"
        [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [ranges]="ranges" [opens]="'left'"
        [showClearButton]="true">
    </div>
</div>
<!-- <label class="label-text">Route Protection</label> 
<nz-select [(ngModel)]="protectionRoute" class="mr-1" style="width: 300px;" [disabled]="isIntegrationsLoaded"
                 (ngModelChange)="protectionRouteValueChanges($event)">
                <nz-option nzValue="all" nzLabel="All"></nz-option>
                <nz-option nzValue="yes" nzLabel="Yes"></nz-option>
                <nz-option nzValue="no" nzLabel="No"></nz-option>            
            </nz-select> -->
</div>
</div>
<div class="table-height dashboard" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" [nzData]="lst_Logs"
        [nzFrontPagination]="false" [nzShowPagination]="false" 
        [ngClass]="{'table-loading' : lst_Logs.length > 0 || isIntegrationsLoaded}">
        <thead class="tablehead">
            <tr class="tableheader">
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('customer')">
                    QB Customer
                </th>
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbinvoicedate')">
                    QB Invoice Date
                </th>
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('qbinvoicedocnumber')">
                    QB Invoice Doc Number
                </th>
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('routeordernumber')">
                <!-- Route Order-->   
                    Aftership Order
                </th>
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('shipmentid')">
                  <!--  Route Shipment</th>-->
                    Aftership Shipment</th>
                <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('note')">
                    Notes</th>
                <!-- <th  [nzAlign]="'left'" [nzSortFn]="true" (nzSortOrderChange)="sort('protection')">
                    Route Protection</th> -->
            </tr>
        </thead>
        <tbody *ngIf="!isIntegrationsLoaded">
            <ng-container *ngFor="let data of lst_Logs;let i = index;let even=even;">
                <tr [ngClass]="{'is-even-row' : even}">
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip [nzTooltipTitle]="data.qboCustomer?.length > 10 ? data.qboCustomer : ''">{{
                        data.qboCustomer }}</td>
                    <td [nzAlign]="'center'"> {{(data.qboInvoiceDate.toString().slice(0,-1) | date : 'MM/dd/yyyy') ==
                        '01/01/0001'? '-'
                        : (data.qboInvoiceDate.toString().slice(0,-1) | date : 'MM/dd/yyyy' )}}</td>
                        <td [nzAlign]="'left'"> {{data.qboInvoiceDocNumber ? data.qboInvoiceDocNumber : '-'
                            
                            }}</td>
                    <!-- <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                    [nzTooltipTitle]="data.routeOrderNumber?.length > 5 ? data.routeOrderNumber : ''">{{
                            data.routeOrderNumber ? data.routeOrderNumber : '-'}}</td> -->
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.routeOrderNumber?.length > 5 ? data.routeOrderNumber : ''">

                        <ng-container *ngIf="data.routeOrderNumber; else noData">
                            <a [href]="'https://badeloft.aftership.com/' + data.routeOrderNumber"
                               target="_blank"
                               rel="noopener noreferrer">
                               {{ data.routeOrderNumber }}
                            </a>
                        </ng-container>

                        <ng-template #noData>-</ng-template>
                    </td>
                    
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.routeShipmentId?.length > 5 ? data.routeShipmentId : ''">{{
                        data.routeShipmentId ? data.routeShipmentId : '-' }}
                    </td>
                    <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.note?.length > 5 ? data.note : ''">{{
                        data.note }}
                    </td>
                    <!-- <td [nzAlign]="'left'" nzEllipsis nz-tooltip
                        [nzTooltipTitle]="data.protection ? 'protected with tracking' : 'not protected with tracking'">{{ data.protection ?
                        'Yes' : 'No' }}
                    </td> -->
                </tr>                
    </ng-container>
    </tbody>
    <ng-container *ngIf="isIntegrationsLoaded">
        <tbody>
            <tr *ngFor="let i of [].constructor(100)">
                <ng-container *ngFor="let i of [].constructor(7)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
    </nz-table>
</div>
